export default "__VITE_ASSET__DPok87Oz__"